import moment from 'moment';
import * as routeBuilder from 'Routes/routeBuilder';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { getDefaultProposal } from 'Utils/proposal/proposalUtils';
import { CRITERIA_OFFSETSELL, CRITERIA_DEPARTURE_CITIES } from 'Utils/request/requestDictionary';
export const PAGE_BE_ACCOMMODATION = 'accommodation';
export const PAGE_BE_TRANSPORT = 'transport';
export const PAGE_BE_SERVICES = 'services';
export const PAGE_BE_ACTIVITIES = 'activities';
export const PAGE_BE_SERVICES_ALL_INCLUSIVE = 'allInclusive';
export const PAGE_BE_PARTICIPANTS = 'participants';
export const PAGE_BE_BANKING = 'banking';
export function getBookingEngineUri(
  page: string = PAGE_BE_ACCOMMODATION,
  proposals: Array<Proposal>,
  resort?: Product,
  selectedProposalId?: string,
  otherQueryParameters?: {},
): string {
  const proposalIds = proposals.map((proposal) => proposal.id);

  const _selectedProposalId = selectedProposalId || getDefaultProposal(proposals, resort)?.id;

  const queryParams = {
    ...otherQueryParameters,
    proposalIds,
    selectedProposalId: _selectedProposalId,
    coderesort: resort?.id,
  };
  return routeBuilder.buildUrl(
    'booking',
    {
      page,
    },
    queryParams,
  );
}
type GQLProps = {
  bookingCriteria: {
    offsetSell: number;
  };
};
export const getBookingCriteriaOffsetSell = async (
  productId: string,
  appContext: AppContext,
): Promise<GQLProps> => {
  const getQuery = () => {
    return `query {
                  bookingCriteria(productId: "${productId}") {
                    offsetSell
                  }
            }`;
  };

  const query = getQuery();
  return graphQLClient.runQuery(query, appContext, {
    requestName: CRITERIA_OFFSETSELL,
  });
};
type BookingCriteriaDepartureCities = {
  bookingCriteria: {
    departureCities: ReadonlyArray<{
      readonly name: string;
      readonly value: string;
    }>;
  };
};
export const getBookingCriteriaDepartureCities = async (
  productId: string,
  appContext: AppContext,
): Promise<BookingCriteriaDepartureCities> => {
  const query = `query {
                  bookingCriteria(productId: "${productId}") {
                      departureCities {
                        value
                        name
                      }
                  }
            }`;
  return graphQLClient.runQuery(query, appContext, {
    requestName: CRITERIA_DEPARTURE_CITIES,
  });
};
// check if the departureDate comes after today plus the offsetSell (in days), which is defined by the API
export const checkIsDepartureDateAvailaible = (
  departureDate: string,
  offsetSell: number,
): boolean => {
  return moment(departureDate).isBefore(moment().add(offsetSell, 'd'), 'day');
};
